import * as React from 'react';
import styled from 'styled-components';

import { useBreakpoint } from 'hooks';
import RouteModeActions from './RouteModeActions';
import RouteDirectionActions from './RouteDirectionActions';

const RouteListHeader: React.FC = () => {
  const { md } = useBreakpoint();

  return (
    <StyledHeader $md={md}>
      <StyledTitle>Route</StyledTitle>
      <StyledActions>
        <RouteModeActions />
        <RouteDirectionActions />
      </StyledActions>
    </StyledHeader>
  );
};

export default RouteListHeader;

const StyledHeader = styled.div<{ $md: boolean }>`
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  ${({ $md }) => `margin: 0px ${$md ? '24px' : '12px'}`}
`;

const StyledTitle = styled.p`
  flex-grow: 1;
  margin: 0;
`;

const StyledActions = styled.div`
  display: flex;
  align-items: center;
`;
